
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "xmlns:a": "http://ns.adobe.com/AdobeSVGViewerExtensions/3.0/",
    "x": "0px",
    "y": "0px",
    "width": "20px",
    "height": "20px",
    "viewBox": "0 0 20 20",
    "enable-background": "new 0 0 20 20",
    "xml:space": "preserve"
  },
  "children": [
    {
      "tag": "defs"
    },
    {
      "tag": "rect",
      "attrsMap": {
        "display": "none",
        "fill": "#F2F2F2",
        "width": "20",
        "height": "20"
      }
    },
    {
      "tag": "rect",
      "attrsMap": {
        "x": "6.253",
        "y": "3",
        "fill": "#AEE4FA",
        "width": "6.96",
        "height": "4.165"
      }
    },
    {
      "tag": "rect",
      "attrsMap": {
        "x": "1",
        "y": "12.835",
        "fill": "#AEE4FA",
        "width": "4.634",
        "height": "4.165"
      }
    },
    {
      "tag": "rect",
      "attrsMap": {
        "x": "7.685",
        "y": "12.835",
        "fill": "#AEE4FA",
        "width": "4.632",
        "height": "4.165"
      }
    },
    {
      "tag": "rect",
      "attrsMap": {
        "x": "14.367",
        "y": "12.835",
        "fill": "#AEE4FA",
        "width": "4.633",
        "height": "4.165"
      }
    },
    {
      "tag": "polygon",
      "attrsMap": {
        "fill": "#AEE4FA",
        "points": "16.658,12.969 15.959,12.969 15.959,9.906 3.866,9.906 3.866,12.969 3.167,12.969 3.167,9.211 \r\n\t16.658,9.211 "
      }
    },
    {
      "tag": "rect",
      "attrsMap": {
        "x": "9.538",
        "y": "6.438",
        "fill": "#AEE4FA",
        "width": "0.7",
        "height": "6.531"
      }
    }
  ]
})
    }
  